import React, { useEffect, useState } from "react";
import API2 from "../../api/indexv2";
import { handleError, notify, deliveryStatus } from "../../components/common/utils";
import { GET_ORDER_DETAIL } from "../../api/apiList";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import Header from "../HeaderNew/component";
import CancelOrderModal from "./cancelOrderModal";
import TrackOrderModal from "./trackOrderModal";
import ratOrderModal from "./ratOrderModal";
import ReturnOrderModal from "./returnOrderModal";
import RaiseIssueModal from "./raiseIssueModal";
import RatingModal from "./ratOrderModal";
import Loader from "../../components/common/loader";
import { ToastContainer } from "react-toastify";
import "./styles.scss";
import { useSelector, useDispatch } from "react-redux";
import {
  ondcOrderStatus,
  ondcIssueStatus,
  ondcOrderTrack,
  completeIssue,
  esclateIssue
} from "../../slices/ondcPostorderSlice";
import { get } from "lodash";
import { types } from "../../components/common/utils";
import ExternalLinkIcon from "../../images/home/external-link-icon.svg"
import starIcon from "../../images/home/star-icon.svg"

import ReactStars from "react-rating-stars-component";
import StarRating from '../OrderDetails/starRating';

const OrderDetails = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState({});
  const [cancelModal, setCancelModal] = useState(false);
  const [trackModal, setTrackModal] = useState(false);
  const [ratingModal, setRatingModal] = useState(false);
  const location = useLocation();
  const [RaiseTicket, setRaiseTicket] = useState(false);
  const [returnModal, setReturnModal] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [actualOrderItems, setActualOrderItems] = useState([]);
  const [cancelledAndReturned, setCancelledAndReturned] = useState([]);
  const [orderAmounts, setOrderAmounts] = useState({
    TotalCurrentItemsAmount: 0,
    TotalOtherChargesAmount: 0,
  });
  const [isHeaderHide, setIsHeaderHide] = useState(false);
  const { ondcOrderstatus,
    ondcIssuestatus,
    ondcTrackOrderstatus,
    ondcComplteIssueStatus,
    ondcEsclateIssueStatus
  } =
    useSelector((state) => ({
      ondcOrderstatus: get(state, "ondcPostorder.ondcOrderstatus", ""),
      ondcIssuestatus: get(state, "ondcPostorder.ondcIssuestatus", ""),
      ondcTrackOrderstatus: get(state, "ondcPostorder.ondcTrackOrderstatus", ""),
      ondcComplteIssueStatus: get(state, "ondcPostorder.ondcComplteIssueStatus", ""),
      ondcEsclateIssueStatus: get(state, "ondcPostorder.ondcEsclateIssueStatus", ""),
    }));
  useEffect(() => {
    getOrderDetail();
    document.body.style.overflow = '';
  }, []);

  const handleWhatsAppButtonClick = (phoneNumber, message) => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsHeaderHide(true);
      } else {
        setIsHeaderHide(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const getOrderDetail = async () => {
    setLoading(true);
    const body = {
      _id: location.state?.orderId,
    };

    try {
      const response = await API2.post(GET_ORDER_DETAIL, body);
      if (response) {
        const data = response?.data?.data
        setOrderData(data);
        setItemData(data?.itemRes);
        const orderItems = data?.itemRes?.filter((item) => item?.type === "Item" && item.quantity.count !== 0)
        const actualOrderItems = data?.itemRes?.filter((item) => item?.type === "Item")
        const cancelledAndReturned = data?.itemRes.filter((item) => (item.type === "Return" || item.type === "Cancel") && item.quantity.count !== 0)
        const updatedOrderItems = orderItems?.map(item => {
          const issueAlreadyRaised = data?.complaints?.some(complain =>
            complain?.items[0]?.productId === item?.id && complain?.raw?.message?.issue?.status === "OPEN"
          );
          return {
            ...item,
            issueAlreadyRaised
          };
        });
        setActualOrderItems(actualOrderItems)
        setOrderItems(updatedOrderItems)
        setCancelledAndReturned(cancelledAndReturned)
        const totalCurrentItemsAmount = data?.itemRes?.reduce((acc, item) => {
          return acc + (parseFloat(item?.discountedPrice ?? 0));
        }, 0);
        let totalOAmount = 0;
        if (data?.otherChargesItems) {
          totalOAmount = data?.otherChargesItems?.reduce((acc, item) => {
            const price = parseFloat(item?.price?.value) ? item?.price?.value : parseFloat(item?.item?.price?.value) ? item?.item?.price?.value : 0
            if (!["item"].includes(item["@ondc/org/title_type"])) {
              return acc + parseFloat(price) || 0;
            }
            return acc;
          }, 0);
        }
        setOrderAmounts({
          TotalCurrentItemsAmount: totalCurrentItemsAmount,
          TotalOtherChargesAmount: totalOAmount,
        });
      }
      setLoading(false);
    } catch (error) {
      handleError(error);
      setLoading(false);
      setOrderData({});
    }
  };

  const getOrdeStatus = () => {
    if (orderData && ondcOrderstatus !== "loading") {
      const res = dispatch(
        ondcOrderStatus({
          orderId: orderData?._id,
        })
      ).then((response) => {
        if (response?.payload?.success) {
          setOrderData((prevState) => ({
            ...prevState,
            orderStatus: response?.payload?.data?.orderStatus,
          }));
        }
        getOrderDetail()
      });
      notify("promise", "Order status fetched successfully!", res);
    }
  };
  const trackOrder = () => {
    dispatch(
      ondcOrderTrack({
        orderId: orderData?._id,
      })
    )
      .then((response) => {
        if (response?.payload?.data?.trackingDetails?.details?.url) {
          notify("success", "Track successfully!");
          const trackingUrl = response?.payload?.data?.trackingDetails?.details?.url;
          window.open(trackingUrl);
        } else {
          notify(
            "error",
            "Cannot proceed with your request now! Please try again later."
          );
        }
      })
      .catch((error) => {
        notify(
          "error",
          "An error occurred while processing your request. Please try again later."
        );
      });
  };

  const getIssueStatus = (issueId) => {
    if (orderData && ondcOrderstatus !== "loading") {
      dispatch(
        ondcIssueStatus({
          orderId: orderData?._id,
          issue_id: issueId,
        })
      ).then((response) => {
        if (response?.payload?.result?.context?.action === "issue_status") {
          notify("success", "Issue status updated successfully!");
          getOrderDetail()
        }
      });
    }
  };

  const closeIssue = (issueId) => {
    if (orderData && ondcOrderstatus !== "loading") {
      dispatch(
        completeIssue({
          orderId: orderData?._id,
          issueId: issueId,
        }),

      ).then((response) => {
        if (response?.payload?.result?.context?.action) {
          getOrderDetail();
          notify("success", "Issue Marked Resolved successfully!");
        }
      });
    }
  };

  const escalateIssue = (issueId) => {
    if (orderData && ondcOrderstatus !== "loading") {
      dispatch(
        esclateIssue({
          orderId: orderData?._id,
          issueId: issueId,
        })
      ).then((response) => {
        if (response?.payload?.result?.context?.action) {
          getOrderDetail()
          notify("success", "Issue Marked Not Resolved successfully!");
        }
      });
    }
  };

  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case "order-delivered":
        return "order-status-title-btn-kl order-status-completed-kl";
      case "packed":
        return "order-status-title-btn-kl order-status-accepted-kl";
      case "cancelled":
        return "order-status-title-btn-kl order-status-cancelled-kl";
      case "pending":
        return "order-status-title-btn-kl order-status-pending-kl";
      default:
        return "order-status-title-btn-kl order-status-placed-kl";
    }
  };


  const ratingChanged = (newRating) => {
    console.log(newRating);
  };

  function getSubcategoryLabel(subcategoryValue) {
    for (const type of types) {
      const subcategory = type.subcategories.find(
        (sub) => sub.value === subcategoryValue
      );
      if (subcategory) {
        return subcategory.label;
      }
    }
    return 'Subcategory not found';
  }

  return (
    <>
      <ToastContainer
        autoClose={300}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        position="top-right"
      />
      <Header hide={isHeaderHide} title={"Orders Details"} />
      <div className="mobile-secondary-header-kl product-detail-mobile-header">
        <div className="mobile-secondary-header-inner-kl">
          <div className="mobile-secondary-header-title-kl">{"Orders Details"}</div>
        </div>
      </div>
      {loading && !orderData?._id ? (
        <div className="dotLoader">
          <Loader />
        </div>
      ) : (
        <>
          <div className="order-details-container-kl">
            <div className="order-details-page-title-kl">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    Orders Details
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-8 mb-m-32">
                  <div className="row">
                    <div className="col-lg-12 pl-m-0 pr-m-0">
                      <div className="order-details-card-kl mb-4">
                        <div className="order-details-card-header-kl">
                          <div className="order-details-card-header-left-kl">
                            <div className="order-details-card-header-title-kl">
                              Order Id: {orderData?.orderId}
                            </div>
                            <div

                              className="seller-shop-kl">
                              Seller: <span
                                onClick={() => {
                                  const encodedValue = encodeURIComponent(orderData?.providerId);
                                  window.open(`/seller?pid=${encodedValue}`, "_blank");
                                }}
                              >
                                {orderData?.delivery?.['@ondc/org/provider_name']}
                                <img className="seller-shop-edit-icon-kl" alt='Icon' src={ExternalLinkIcon} />
                              </span>
                            </div>
                            <div className="order-status-time-kl">
                              Ordered On:{" "}
                              {dayjs(orderData?.createdAt).format(
                                "MMM D, YYYY h:mm A"
                              )}{" "}
                              <span>|</span> Payment: Prepaid
                            </div>
                          </div>
                          <div className="order-details-card-header-right-kl">
                            <div className="order-status-title-kl">Order Status </div>
                            <button className={getStatusClass(orderData?.deliveryStatus)} type="button">{orderData?.orderStatus === "Cancelled" ? orderData?.orderStatus : deliveryStatus(orderData?.deliveryStatus)}</button>
                          </div>
                        </div>
                        <div className="order-details-card-body-kl">
                          <div className="order-details-card-list-kl">
                            {orderItems?.length > 0 && orderItems?.map((item, index) => {
                              return (
                                <div key={index} className="order-details-card-items-kl">
                                  <div className="order-details-card-items-container-kl">
                                    <div className="order-detail-product-img-kl">
                                      {item?.productImages &&
                                        item?.productImages
                                          ?.length > 0 && (
                                          <img
                                            src={
                                              item.productImages?.[0]
                                            }
                                            alt={item?.title}
                                          />
                                        )}
                                    </div>
                                    <div>
                                      {item?.productName && <div className="order-detail-product-title-kl">{item?.productName}</div>}
                                      {item?.quantity?.count && (<>
                                        <div className="order-detail-product-title-kl">QTY: {item?.quantity?.count}</div>
                                        <div className="order-detail-product-shop-name-kl">₹ {item?.discountedPrice}</div>
                                      </>)}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          {cancelledAndReturned?.length > 0 && cancelledAndReturned?.map((item, index) => {
                            return (
                              <div className="order-details-card-list-kl">
                                <div key={index} className="order-details-card-items-kl">
                                  <div className="order-details-card-items-container-kl">
                                    <div className="order-detail-product-img-kl">
                                      {item?.productImages &&
                                        item?.productImages
                                          ?.length > 0 && (
                                          <img
                                            src={
                                              item.productImages?.[0]
                                            }
                                            alt={item?.title}

                                          />
                                        )}
                                    </div>
                                    <div>
                                      {item?.productName && <div className="order-detail-product-title-kl">{item?.productName}</div>}

                                      {item?.quantity?.count && (
                                        <div className="order-detail-product-title-kl">
                                          {item?.quantity?.count}
                                          * Base Price
                                        </div>
                                      )}
                                      <div className="order-detail-product-shop-name-kl">
                                        {item?.discountedPrice && (parseFloat(item?.discountedPrice) !== parseFloat(item?.refundAmount)) &&
                                          <span style={{ textDecoration: "line-through", marginRight: "8px" }}>
                                            ₹{item?.discountedPrice}
                                          </span>}
                                        <span>
                                          ₹{item?.refundAmount?.toFixed(2)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="product-canceled-details-kl">
                                    <div className="product-canceled-title-kl">{item?.status}</div>
                                    {
                                      (item?.logisticsProviderName && item?.status !== "Return_Delivered") &&
                                      <>
                                        <div className="product-canceled-sub-title-kl">Return will be picked up by : {item?.logisticsProviderName}</div>
                                        {item?.pickUpOTP &&
                                          <div className="product-canceled-sub-title-kl">
                                            PICK UP OTP : {item?.pickUpOTP}
                                          </div>
                                        }
                                      </>
                                    }
                                    {
                                      item?.refundStatus &&
                                      <>
                                        <div className="product-canceled-sub-title-kl">Refund Status:{item?.refundStatus === "Completed" ? " Amount Refunded" : "Pending"}</div>
                                        <div className="product-canceled-sub-title-kl">Item Refund Amount: {item?.refundAmount.toFixed(2)}</div>
                                      </>
                                    }
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          {(cancelledAndReturned?.length > 0 && orderData?.totalRefundAmount > 0) &&
                            <div
                              className="total-refund-amount-kl"
                            >
                              <div className="total-refund-amount-items-kl">
                                {`Total Refund Amount (incl. other charges)`}
                              </div>
                              <div className="total-refund-amount-items-kl">
                                ₹{orderData?.totalRefundAmount}
                              </div>
                            </div>
                          }
                        </div>
                        <div className="order-details-card-footer-kl">
                          <div className="summary-footer-btn m-0">
                            {
                              (orderData?.orderStatus === "Accepted" || orderData?.orderStatus === "Created")
                              && itemData?.filter((item) => item.type === "Item")?.every(item => item?.isCancellable === true) &&
                              <button type="button"
                                className="btn raise-issue-order-btn cancel-return-order-btn"
                                onClick={() => {
                                  setCancelModal(true);
                                }}
                                disabled={ondcOrderstatus === "loading"}
                              >
                                Cancel Order
                              </button>
                            }
                            {
                              orderData?.orderStatus !== "Cancelled" &&
                              orderItems?.length > 0 &&
                              (
                                <>
                                  <button type="button"
                                    className="btn raise-issue-order-btn"
                                    onClick={() => {
                                      setRaiseTicket(true);
                                    }}
                                    disabled={ondcOrderstatus === "loading"}
                                  >
                                    Raise Issue
                                  </button>
                                </>
                              )}
                            {orderData?.orderStatus === "Completed" && orderItems?.length > 0 &&
                              itemData?.filter((item) => item.type === "Item")?.some(item => item?.isReturnable === true) &&
                              (
                                <>
                                  <button type="button"
                                    onClick={() => {
                                      setReturnModal(true);
                                    }}
                                    className="btn cancel-return-order-btn"
                                    disabled={ondcOrderstatus === "loading"}
                                  >
                                    Return
                                  </button>
                                </>
                              )}
                            {(orderData?.deliveryStatus === "Order-picked-up" || orderData?.deliveryStatus === "Out-for-delivery") &&
                              <button type="button"
                                className="btn raise-issue-order-btn"
                                onClick={() => trackOrder()}
                                disabled={ondcOrderstatus === "loading"}
                              >
                                {ondcTrackOrderstatus === "loading"
                                  ? "Please Wait..."
                                  : "Track Order"}
                              </button>
                            }
                            <button type="button"
                              className="btn raise-issue-order-btn"
                              onClick={() => getOrdeStatus()}
                            >
                              {ondcOrderstatus === "loading"
                                ? "Please Wait..."
                                : "Get Status"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 pl-m-0 pr-m-0">
                      {orderData?.delivery &&
                        <div className="order-details-card-kl">
                          <div className="order-details-card-body-kl">
                            <div className="delivered-to-container-kl">
                              <div className="delivered-to-title-kl">Delivered To</div>
                              <div className="delivered-to-name-kl">
                                {orderData?.delivery?.end?.location?.address?.name},
                              </div>
                              <div className="delivered-to-address-kl">{orderData?.delivery?.end?.contact?.phone}</div>
                              <div className="delivered-to-address-kl">
                                {orderData?.delivery?.end?.location?.address?.locality}
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {orderData?.complaints && orderData?.complaints.length > 0 && (
                        <div className="complaints-block">
                          <div className="card-accordion">
                            <div className="accordion" id="accordionExample">
                              {orderData?.complaints.map((complaint, complaintIndex) => {
                                const issue = complaint.raw?.message?.issue
                                const resActions = complaint?.raw?.message?.issue?.issue_actions?.respondent_actions
                                const complainant_actions = complaint.raw?.message?.issue?.issue_actions?.complainant_actions
                                const respondent_actions = complaint.raw?.message?.issue?.issue_actions?.respondent_actions
                                const description = complaint?.raw?.message?.issue?.description
                                const resolution = complaint?.raw?.message?.issue?.resolution
                                return (
                                  <div className="accordion-item" key={complaintIndex}>
                                    <h2 className="accordion-header" id={`heading${complaintIndex}`}>
                                      <button type="button"
                                        className="accordion-button p-0"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse${complaintIndex}`}
                                        aria-expanded={complaintIndex === 0 ? "true" : "false"}
                                        aria-controls={`collapse${complaintIndex}`}
                                      >
                                        Complaints {complaintIndex + 1}
                                      </button>
                                    </h2>
                                    <div className="complaints-flex">
                                      <div className="complaints-items">
                                        <div className="d-flex gap-2 align-items-center">
                                          <div>
                                            <h1 className="missing-item-title">
                                              {issue?.category} -
                                              {getSubcategoryLabel(issue.sub_category)}
                                            </h1>
                                            <div className="issue-id-text">
                                              Issue raised on {dayjs(issue?.created_at).format("MMM D, YYYY h:mm A")}
                                            </div>
                                            <div className="issue-id-text">Issue Id: {complaint?.issue_id}</div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="complaints-status">
                                        <div className="status-text">Status: <span className="green">{issue?.status}</span></div>
                                        <p> Expected response time:  {dayjs(issue?.created_at).add(1, "hour").format("MMM D, YYYY h:mm A")}</p>
                                        <p> Expected resolution time:  {dayjs(issue?.created_at).add(1, "day").format("MMM D, YYYY h:mm A")}</p>
                                      </div>
                                    </div>
                                    <div
                                      id={`collapse${complaintIndex}`}
                                      className={`accordion-collapse collapse ${complaintIndex === 0 ? "show" : ""}`}
                                      aria-labelledby={`heading${complaintIndex}`}
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body p-0">
                                        <div className="complaints-msg">
                                          <div className="complaints-msg-text"><b>Subject:</b> {description?.short_desc}</div>
                                        </div>
                                        <div className="complaints-msg">
                                          <div className="complaints-msg-text"><b>Message:</b> {description?.long_desc}</div>
                                        </div>
                                        <div className="complaints-msg border-0">
                                          <div className="complaints-msg-text"><b>Action Taken</b></div>
                                        </div>
                                        <div className="Complaint-created-block">
                                          {complainant_actions &&
                                            complainant_actions.filter(action => action?.complainant_action !== "CLOSE")
                                              .map((item, index) => (
                                                <div className="Complaint-created-flex" key={index}>
                                                  <div className="d-flex gap-2 align-items-start">
                                                    <div className="created complaint-green">
                                                      <p></p>
                                                    </div>
                                                    <div className="action-text-flex">
                                                      <div className="action-taken-text"><b>{item.short_desc}</b></div>
                                                      <div className="action-taken-text">Updated by: {item.updated_by?.person?.name}, {complaint.raw?.context?.bap_id}</div>
                                                      <div className="action-taken-text">Updated at: {dayjs(item.updated_at).format("MMM D, YYYY h:mm A")}</div>
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <div className="action-taken-right">Actions: {item.complainant_action}</div>
                                                  </div>
                                                </div>
                                              ))
                                          }
                                          {respondent_actions &&
                                            respondent_actions.map((action, index) => (
                                              <div className="Complaint-created-flex" key={index}>
                                                <div className="d-flex gap-2 align-items-start">
                                                  <div className={index !== complaint.raw.message.issue.issue_actions.respondent_actions.length - 1 || action.respondent_action === "RESOLVED" ? "created complaint-green" : "created complaint"}>
                                                    <p></p>
                                                  </div>
                                                  <div className="action-text-flex">
                                                    <div className="action-taken-text"><b>{action.short_desc}</b></div>
                                                    <div className="action-taken-text">Updated by: {action.updated_by?.person?.name}, {complaint.raw?.context?.bpp_id}</div>
                                                    <div className="action-taken-text">Updated at: {dayjs(action.updated_at).format("MMM D, YYYY h:mm A")}</div>
                                                  </div>
                                                </div>
                                                <div>
                                                  <div className="action-taken-right">Actions: {action.respondent_action}</div>
                                                </div>
                                              </div>
                                            ))
                                          }
                                          {complainant_actions &&
                                            complainant_actions.filter(action => action?.complainant_action === "CLOSE")
                                              .map((action, index) => (
                                                <div className="Complaint-created-flex" key={index}>
                                                  <div className="d-flex gap-2 align-items-start">
                                                    <div className={index !== complainant_actions.length - 1 ? "created complaint-green" : "created complaint"}>
                                                      <p></p>
                                                    </div>
                                                    <div>
                                                      <p><b>{action?.short_desc}</b></p>
                                                      <p>Updated by: {action?.updated_by?.person?.name}, {complaint?.raw?.context?.bpp_id}</p>
                                                      <p>Updated at: {dayjs(action?.updated_at).format("MMM D, YYYY h:mm A")}</p>
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <p><b>Actions: </b>{action?.complainant_action}</p>
                                                  </div>
                                                </div>
                                              ))
                                          }
                                        </div>
                                        {resolution &&
                                          <div className="Respondent">
                                            <div>
                                              {resolution?.short_desc && <p><b>Resolution :  {resolution?.short_desc} </b></p>}
                                              {resolution?.long_desc && <p>Description: {resolution?.long_desc}</p>}
                                              {resolution?.action_triggered && <p>Action Taken: {resolution?.action_triggered}</p>}
                                              {resolution?.refund_amount && <p>Refund Amount: {resolution?.refund_amount}</p>}
                                            </div>

                                          </div>
                                        }
                                        <div className="Respondent">
                                          <div className="respondent-flex">
                                            <div className="respondent-heading">Respondent </div>
                                            <div className="respondent-text">Email: {resActions?.[0]?.updated_by?.contact?.email}</div>
                                            <div className="respondent-text m-0">Phone: {resActions?.[0]?.updated_by?.contact?.phone}</div>
                                          </div>
                                          <div className="get-status-btn">
                                            <button type="button"
                                              onClick={() => getIssueStatus(issue?.id)}
                                              className="btn btn-outline"
                                              disabled={ondcIssuestatus === "loading"}
                                            >
                                              {ondcIssuestatus === "loading" ? "Please Wait..." : "Get Status"}
                                            </button>
                                          </div>
                                          {resActions?.slice(-1)[0]?.respondent_action === "RESOLVED" && complainant_actions.some(action => action?.complainant_action === "CLOSE") === false &&
                                            <div>
                                              <button type="button"
                                                onClick={() => escalateIssue(complaint._id)}
                                                className="btn btn-outline"
                                                disabled={ondcEsclateIssueStatus === "loading"}
                                              >
                                                {ondcEsclateIssueStatus === "loading" ? "Please Wait..." : "Escalate Issue"}
                                              </button>
                                            </div>
                                          }
                                          {resActions?.slice(-1)[0]?.respondent_action === "RESOLVED" && !complainant_actions.some(action => action?.complainant_action === "CLOSE") &&
                                            <div>
                                              <button type="button"
                                                onClick={() => closeIssue(complaint._id)}
                                                className="btn btn-outline"
                                                disabled={ondcComplteIssueStatus === "loading"}
                                              >
                                                {ondcComplteIssueStatus === "loading" ? "Please Wait..." : "Mark Resolved"}
                                              </button>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 pl-0- pr-0-">
                  <div className="row">
                    {<div className="col-lg-12">
                      <div className="order-details-card-kl mb-4">
                        <div className="order-details-card-header-kl">
                          <div className="order-summary-heading-kl">Order Summary
                          </div>
                        </div>
                        <div className="order-details-card-body-kl">
                          <div className="order-details-summary-inner-kl">

                            <div className="order-detail-item-total-kl">
                              <div className="item-total-heading-kl">Item Total ({actualOrderItems?.length} {actualOrderItems?.length > 1 ? "Items" : "Item"})</div>
                              <div className="order-total-amount-kl">₹ {orderAmounts?.TotalCurrentItemsAmount}</div>
                            </div>
                            <div className="order-detail-block-kl">
                              {orderData?.otherChargesItems?.map((item, index) => {
                                const rtoCharges = item["@ondc/org/item_id"] !== orderData?.delivery?.id
                                return (
                                  item["@ondc/org/title_type"] !== "item" && item["title"] !== "ONDC_FA" &&

                                  <div className="order-details-list-kl" key={index}>
                                    <div className="order-detail-item-kl">
                                      {item?.title && `${item?.title} ${rtoCharges ? "(RTO)" : ""}`}
                                    </div>
                                    <div className="order-detail-item-kl">₹ {parseFloat(item.price.value) ? item.price.value : parseFloat(item?.item?.price?.value) ? item.item.price.value : 0}</div>
                                  </div>
                                )
                              })}
                            </div>
                            <div
                              className="order-details-summary-total-kl"
                            >
                              <div className="order-details-summary-total-items">
                                Sub Total
                              </div>
                              <div className="order-details-summary-total-items">
                                ₹{orderAmounts?.TotalOtherChargesAmount?.toFixed(2)}
                              </div>
                            </div>
                            <div
                              className="order-details-summary-total-kl"
                            >
                              <div className="order-details-summary-total-items">
                                Total Amount
                              </div>
                              <div className="order-details-summary-total-items">
                                ₹{((orderAmounts?.TotalCurrentItemsAmount + orderAmounts?.TotalOtherChargesAmount).toFixed(2))}
                              </div>
                            </div>
                            {orderData?.isOfferApply && <div
                              className="order-details-offer-amount-kl"
                            >
                              <div className="offer-amount-items-kl">
                                Offer Amount ({orderData?.offerData?.couponCode})
                              </div>
                              <div className="offer-amount-items-kl"
                              >
                                - ₹{orderData?.offerData?.discountedValue?.toFixed(2)}
                              </div>
                            </div>}
                            <div className="order-details-grand-total-kl">
                              <div className="order-details-grand-total-items"> Grand Total</div>
                              <div className="order-details-grand-total-items">₹ {(parseFloat(orderAmounts?.TotalCurrentItemsAmount?.toFixed(2)) + parseFloat(orderAmounts?.TotalOtherChargesAmount?.toFixed(2)) - parseFloat((orderData?.offerData?.discountedValue ?? 0)?.toFixed(2)))?.toFixed(2)}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                  </div>
                  {process.env.REACT_APP_SERVER === "DEVELOPMENT" &&
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="order-details-card-kl mb-4">
                          <div className="order-details-card-body-kl">
                            <div className="order-detail-need-support-container-kl">
                              <div className="order-detail-need-support-title-kl rate-order-title mb-0 text-decoration-underline cursor-pointer"
                                // data-bs-toggle="modal"
                                // data-bs-target="#staticBackdrop"  
                                onClick={() => setRatingModal(true)}
                              >

                                {!orderData?.averageRating ? "Rate Order" :
                                  <div class="rating-box">
                                    <span class="rating-text">
                                      You rated <span class="rating-score">{orderData?.averageRating}</span>
                                      <span class="star-icon">★</span>
                                    </span>
                                    <span class="view-review">View Your Review ➤</span>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="order-details-card-kl mb-4">
                        <div className="order-details-card-body-kl">
                          <div className="order-detail-need-support-container-kl">
                            <div className="order-detail-need-support-title-kl">
                              Need Support
                            </div>
                            <div onClick={() => {
                              handleWhatsAppButtonClick(
                                "+918108211231",
                                "Hey! I need a help on kikoshop.in"
                              );
                            }} className="chat-with-us-btn">
                              Chat With Us
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* <ratOrderModal /> */}


      {/* Modal */}

      {cancelModal && (
        <CancelOrderModal
          setCancelModal={setCancelModal}
          getOrderDetail={getOrderDetail}
          cancelModal={cancelModal}
          orderId={orderData?._id}
        ></CancelOrderModal>
      )}
      {returnModal && (
        <ReturnOrderModal
          setReturnModal={setReturnModal}
          getOrderDetail={getOrderDetail}
          returnModal={returnModal}
          orderId={orderData?._id}
          itemData={orderItems}
        ></ReturnOrderModal>
      )}
      {RaiseTicket && (
        <RaiseIssueModal
          setRaiseTicket={setRaiseTicket}
          getOrderDetail={getOrderDetail}
          RaiseTicket={RaiseTicket}
          orderId={orderData?._id}
          itemData={orderItems}
          orderStatus={orderData?.orderStatus}
        ></RaiseIssueModal>
      )}
      {trackModal && (
        <TrackOrderModal
          setTrackModal={setTrackModal}
          trackModal={trackModal}
        ></TrackOrderModal>
      )}
      {ratingModal && (
        <RatingModal
          setRatingModal={setRatingModal}
          getOrderDetail={getOrderDetail}
          ratingModal={ratingModal}
          orderData={orderData}
          itemData={orderItems}
        ></RatingModal>
      )}

    </>
  );
};
export default OrderDetails;
